import * as uuid from "uuid";

export class Player {
  public id = uuid.v4();
  public createdAt: Date = new Date();
  public name = "";
}
